import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import { Col, Row, Select, Table } from "antd";
import {
  StarOutlined,
  StarFilled,
  ArrowLeftOutlined,
  SearchOutlined,
  DownloadOutlined,
  PrinterFilled,
} from "@ant-design/icons";
import "./index.css";
import { HeaderStockData } from "./data";
import { Prompt, useHistory } from "react-router";
// import { isEmpty } from "lodash";
import useBeforeUnload from "../../components/Prompting";
import { isEmpty } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { loadItems } from "../../store/items/actions";
import { toast, ToastContainer } from "react-toastify";

const StockSummaryReport = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const itemList =
    props.location && props.location.state ? props.location.state.itemList : "";
  const totalStockValue =
    props.location && props.location.state
      ? props.location.state.stockValue
      : 0;
  const mode =
    props.location && props.location.state ? props.location.state.mode : "";
  const categoryOptions =
    props.location && props.location.state
      ? props.location.state.categoryOptions
      : [];

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
    dispatch(loadItems(itemList));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  console.log(mode, "mode");
  console.log(categoryOptions, "categoryOptions");
  console.log(itemList, "itemList");

  //Reducer state
  const { items_list = [] } = useSelector((state) => state.Items);

  //States data
  const [selectDays, setSelectDays] = useState([]);
  const [itemCategory, setItemCategory] = useState([]);
  const [favourite, setFavourite] = useState([]);

  const [itemRows, setItemRows] = useState([
    {
      itemName: "",
      itemNameValue: "",
      itemCode: "",
      salesPrice: "",
      purchasePrice: "",
      categoryId: "",
      categoryName: "",
      stockQTY: "",
      batchDetails: "",
      createdAt: "",
      createdBy: "",
      customFields: "",
      gstPercentageId: "",
      image: "",
      isProduct: "",
      isService: "",
      measuringId: "",
      serialDetails: "",
      serialMeasuringId: "",
      stockValue: "",
      updatedAt: "",
      _id: "",
      index: "",
      action: "",
      status: "",
    },
  ]);

  const itemsDataTable =
    items_list && items_list.length > 0
      ? items_list.map((data, index) => {
          const categoryName =
            categoryOptions && categoryOptions.length > 0
              ? categoryOptions.find(
                  (category) => category.value === data.categoryId
                )
              : "";

          const categoryNameValue = !isEmpty(categoryName)
            ? categoryName.label
            : "";
          return {
            index: index + 1,
            itemName: data.itemName,
            itemNameValue: data.itemName,
            _id: data._id,
            itemCode: data.itemCode,
            salesPrice: data.salesPrice,
            purchasePrice: data.purchasePrice,
            stockQTY: data.noofStock,
            batchDetails: data.batchDetails,
            createdAt: data.createdAt,
            createdBy: data.createdBy,
            customFields: data.customFields,
            categoryId: data.categoryId,
            categoryName: data.categoryName,
            categoryNameValue: categoryNameValue,
            gstPercentageId: data.gstPercentageId,
            gstPercentageName: data.gstPercentageName,
            serialMeasuringId: data.serialMeasuringId,
            serialMeasuringName: data.serialMeasuringName,
            image: data.image,
            itemCodeValue: data.itemCode,
            salesPriceValue: data.salesPrice,
            purchasePriceValue: data.purchasePrice,
            stockValue: data.noofStock,
            categoryIdValue: data.categoryId,
            descriptionValue: data.description,
            isProduct: data.isProduct,
            isService: data.isService,
            measuringId: data.measuringId,
            description: data.description,
            serialDetails: data.serialDetails,
            updatedAt: data.updatedAt,

            status: data.status,
          };
        })
      : [];

  useEffect(() => {
    if (itemsDataTable && itemsDataTable.length > 0) {
      setItemRows(itemsDataTable);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items_list]);

  const stockReportRoutes = () => {
    history.push({
      pathname: "/items",
    });
  };

  //Download functionality
  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType });

    const a = document.createElement("a");
    a.download = fileName;
    a.href = window.URL.createObjectURL(blob);
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    });
    a.dispatchEvent(clickEvt);
    a.remove();
  };

  const exportToCsv = () => {
    // setDownloadLoading(true);

    setTimeout(() => {
      let headerData = [
        "Item Name, Item Code,  PurchasePrice,Selling Price, Stock Quantity, Stock Value",
      ];

      let usersCsv = !isEmpty(itemRows)
        ? itemRows.reduce((acc, user) => {
            const {
              itemName,
              itemCode,
              purchasePrice,
              salesPrice,
              stockQTY,
              stockValue,
            } = user;
            acc.push([
              itemName,
              itemCode,
              purchasePrice,
              salesPrice,
              stockValue,
              stockQTY,
            ]);

            console.log("test", acc);
            return acc;
          }, [])
        : false;
      console.log(usersCsv, "usersCsv");

      const usersList =
        !isEmpty(usersCsv) && usersCsv.length > 0 ? usersCsv : [];

      downloadFile({
        data: [...headerData, ...usersList].join("\n"),
        fileName: "StockSummary.csv",
        fileType: "text/csv",
      });
      //   setDownloadLoading(false);
    }, 2500);
  };

  useBeforeUnload({
    when: !isEmpty(selectDays),
    message: "Are you sure you want to leave?",
  });

  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Stock Summary | Mbook</title>
        </MetaTags>
      </div>

      <Row className="border-solid rounded-sm bg-[#ffffff]">
        {/* <Skeleton.Input
          style={{
            padding: "5px",
            width: "100%",
          }}
          active={true}
          size={"large"}
        > */}
        <Col
          span={24}
          className="border pt-3 pb-3 border-b-1 border-x-0 border-t-0"
        >
          <div className="font-poppins flex pl-[20px]">
            <div className="flex">
              <ArrowLeftOutlined
                onClick={() => stockReportRoutes()}
                className="font-bold text-[18px]"
              />
              <h1
                style={{
                  fontFamily: "Poppins",
                }}
                className="text-[18px] mt-1 ml-2 font-medium"
              >
                {mode !== "Stock Value" ? "Low Stock Summary" : "Stock Summary"}
              </h1>
            </div>
            <div
              onClick={() => setFavourite(!favourite)}
              className={
                favourite === true
                  ? "cursor-pointer flex bg-[#fcf6ed] ml-6 pl-2 pr-2 p-1 rounded-md border-none"
                  : "cursor-pointer flex bg-[#e9e9e9] ml-6 pl-2 pr-2 p-1 rounded-md border-none"
              }
            >
              {favourite === true ? (
                <StarFilled
                  onClick={() => setFavourite(false)}
                  className="font-bold text-[#ffc107] text-[16px] mr-2"
                />
              ) : (
                <StarOutlined
                  onClick={() => {
                    setFavourite(true);
                    toast.success("Favourite updated successfully");
                  }}
                  className="font-bold text-[16px] mr-2"
                />
              )}
              Favorite
            </div>
          </div>
        </Col>
        {mode !== "Stock Value" ? (
          ""
        ) : (
          <Col span={24} className="flex justify-between mt-4">
            <Row className="pl-3 mb-2 mt-2 ml-1">
              <Col span={12}>
                <Select
                  style={{
                    width: 200,
                    height: 40,
                  }}
                  value={itemCategory}
                  onChange={(e) => {
                    setItemCategory(e);
                  }}
                  suffixIcon={<SearchOutlined className="text-[12px]" />}
                  onSearch={true}
                  placeholder="Select Categories"
                  options={categoryOptions}
                />
              </Col>
              <Col span={12}>
                <div className="pl-2">
                  <Select
                    style={{
                      width: 200,
                      fontSize: "12px",
                      height: 38,
                      fontFamily: "Poppins",
                      color: "black",
                    }}
                    value={selectDays}
                    onChange={(e) => setSelectDays(e)}
                    placeholder="Select Days"
                    options={[]}
                  />
                </div>
              </Col>
            </Row>
            <Col span={12}>
              <Row className="pl-[70px] mt-2">
                <Col span={11} className="pr-3 cursor-pointer">
                  <div
                    onClick={() => exportToCsv()}
                    className="w-[100%] flex justify-center border p-2 rounded-md border-1 text-center"
                  >
                    <p className="flex">
                      <DownloadOutlined className="text-[16px] mr-3" /> Download
                    </p>
                  </div>
                </Col>
                <Col span={11} className="pr-3 cursor-pointer">
                  <div className="flex justify-center w-[100%] border p-2 rounded-md  border-1 text-center">
                    <p className="flex">
                      <PrinterFilled className="text-[16px] mr-3" /> Print PDF
                    </p>
                  </div>
                </Col>
              </Row>
            </Col>
          </Col>
        )}

        <Col span={24} className="p-4 mt-[4px] mb-[100px]">
          <div className="text-[15px] flex w-[100%] border border-b-0 mb-[-5px] p-5 border-t-1 border-x-1">
            <h1
              className="font-semibold"
              style={{
                fontFamily: "Poppins",
                color: "#76797c",
              }}
            >
              Total Stock Value:
            </h1>
            <p className="font-semibold ml-3">
              {"₹ "}
              {totalStockValue}
            </p>
          </div>
          <Table
            style={{
              overflow: "hidden",
              fontFamily: "Poppins",
            }}
            rootClassName="expense-transaction-table"
            bordered
            columns={HeaderStockData}
            // dataSource={TableData}
            dataSource={
              itemRows.length > 0 && !isEmpty(itemRows[0].itemNameValue)
                ? itemRows
                : itemsDataTable
            }
            sortDirections={"ascend"}
            loading={loading ? true : false}
            showSorterTooltip={"sorter-icon"}
            pagination={false}
            // rowSelection={{
            //   type: selectionType,
            //   ...rowSelection,
            // }}
            // rowSelection={{}}
            scroll={{ y: 160 }}
          />
        </Col>
      </Row>
      <Prompt
        when={!isEmpty(selectDays)}
        message="Are you sure you want to leave?"
      />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        style={{
          fontSize: "12px",
        }}
        pauseOnHover
        theme="colored"
      />
    </React.Fragment>
  );
};

export default StockSummaryReport;
